import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
// import { Option } from 'src/app/models/exercise.model';
import { Option } from 'src/app/shared/models/exercise.model'

@Component({
  selector: 'app-text-text-mfq',
  templateUrl: './text-text-mfq.component.html',
  styleUrls: ['./text-text-mfq.component.css']
})
export class TextTextMfqComponent implements OnInit, OnChanges {
  map: { [key: string]: string } = {};
  corrects: boolean[] = [];
  optionsToDisplay: string[] = []
  value: string[] = [];
  answers: any[] = [];
  @Input() answer: any;
  @Input() allOptionsToDisplay: string[];
  @Input() options: Option[];
  @Input() isSubmitted: boolean = false;
  @Input() immediateFeedBackRequired: boolean = false;
  @Input() questionChecked: boolean = false;
  @Input() correctAnswers;
  @Output() showNextButton = new EventEmitter<Object>();
  constructor() { }
  ngOnChanges(changes: any) {
    changes.correctAnswers && this.updateCorrectAnswers(changes.correctAnswers.currentValue);
  }
  ngOnInit() {
    if (this.options.length) {
      this.setOptions();
    }
    if (this.answer) {
      this.updateCorrectAnswers();
      let res = this.value.every(e => e.length > 0);
      if (res) this.showNextButton.emit({ nextButton: true, map: this.map });
    }
  }

  updateCorrectAnswers(currentValue?: any): any {
    this.map = JSON.parse(this.answer);
    for (let o in this.map) {
      let i = this.options.findIndex((i) => i._id == o);
      if (i > -1) {
        this.answers[i] = this.map[o];
        this.value[i] = this.map[o];
        if (currentValue && currentValue.length && Object.keys(currentValue).some(k => currentValue[k])) {
          this.corrects[i] = currentValue.includes(o);
        }
      }
    }
  }





  setOptions() {
    this.value = Array(this.options.length).fill('');
    this.options.forEach(el => this.optionsToDisplay.push(el.mfAnswer));
    if (this.allOptionsToDisplay && this.allOptionsToDisplay.length) {
      this.allOptionsToDisplay.forEach(el => this.optionsToDisplay.push(el));
    }
    this.optionsToDisplay = this.shuffle(this.optionsToDisplay);
  }


  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }


  get isAnyQuestionIncorrect() {
    return this.corrects.some(el => !el);
  }


  onValueChange(index) {
    this.map[this.options[index]._id] = this.value[index];
    let res = this.value.every(e => e.length > 0);
    if (res) this.showNextButton.emit({ nextButton: true, map: this.map });
    console.log(this.map);
  }
}
